<template>
    <v-window v-model="step">
        <!-- unused -->
        <v-window-item class="pb-1" :value="0">
            <v-list
                subheader
                class="d-flex justify-center mt-3"
                :style="$vuetify.display.mobile ? 'height: 50vh; overflow: auto' : ''"
                lines="two"
            >
                <v-radio-group v-model="selectedTemplate">
                    <v-list-item
                        v-for="(item, index) in items"
                        :key="item.id"
                        :class="index === 0 ? 'mt-1 mb-3 oss-list-item' : 'my-1 oss-list-item'"
                        @click="selectedTemplate = item"
                    >
                        <v-radio :key="'selector:' + item.id" class="mt-2" :value="item" />
                        <v-list-item-title
                            class="mb-2"
                            style="text-overflow: ellipsis; max-width: 600px"
                        >
                            <h4>{{ item.name }}</h4>
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-1"
                            >Proposé par
                            {{
                                item.companyScope.accountingCompanyOwner.name
                            }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle>{{
                            getTargets(item.companyScope)
                        }}</v-list-item-subtitle>
                        <span
                            class="mt-2"
                            style="font-weight: ligther; font-size: 8pt; color: green"
                            v-if="index === 0"
                            >Recommandé</span
                        >
                        <template v-slot:append class="my-0">
                            <div class="d-flex justify-center align-center">
                                <v-btn-icon
                                    icon="$oss-eye"
                                    @click="
                                        selectedTemplate = item;
                                        step = 1;
                                    "
                                />
                            </div>
                        </template>
                    </v-list-item>
                </v-radio-group>
            </v-list>
        </v-window-item>
        <v-window-item class="pb-1" :value="1">
            <booklet-content
                v-if="bundleBookletTemplate"
                :booklet="bundleBookletTemplate.content"
                :initialBooklet="bundleBookletTemplate.content"
                :previewMode="true"
                :key="bundleBookletTemplate.id"
                :bundleType="bundleType"
                :importFilesMillesimfromBundle="importFilesMillesimfromBundle"
                @booklet-changed="setContentToUpsert($event)"
            ></booklet-content>
        </v-window-item>
    </v-window>
</template>

<script lang="ts">
import _ from "lodash";

import BookletContent from "../../bookletTemplate/BookletContent.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { Emit } from "vue-facing-decorator";

@Component({
    components: {
        // BookletTemplate,
        BookletContent,
    },
})
export class BookletGenerator extends Vue {
    @Prop({ default: null }) readonly bundleId: string;
    @Prop({ default: null }) bundleType: string;
    @Prop({ default: null }) importFilesMillesimfromBundle: string;
    @Model({}) bundleBookletTemplate: any;

    step = 1;

    selectedTemplate = null;

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get accountingPeriodId() {
        return this.$store.state.accountingPeriod.selectedAccountingPeriod.id;
    }

    items: Array<any> = [];

    loading = false;

    // async generateBooklet() {
    //     this.loading = true;
    //     const result: any = await this.$apollo.mutate({
    //         mutation: gql`
    //             mutation exportTaxFormBooklet(
    //                 $companyId: ID!
    //                 $accountingPeriodId: ID!
    //                 $bundleId: ID!
    //                 $content: Json!
    //             ) {
    //                 exportTaxFormBooklet(
    //                     data: {
    //                         companyId: $companyId
    //                         accountingPeriodId: $accountingPeriodId
    //                         bundleId: $bundleId
    //                         content: $content
    //                     }
    //                 ) {
    //                     output
    //                 }
    //             }
    //         `,
    //         variables: {
    //             companyId: this.companyId,
    //             accountingPeriodId: this.accountingPeriodId,
    //             bundleId: this.bundleId,
    //             content: this.bundleBookletTemplate.content,
    //         },
    //     });
    //     if (result && !result?.data) {
    //         debugger;
    //     }
    //     this.loading = false;
    // }

    previous() {
        if (this.step !== 0) {
            this.step = this.step - 1;
        }
    }

    getTargets(companyScope) {
        let targets = "Pour ";
        if (companyScope.accountingCompany) {
            if (companyScope.clients.length) {
                targets +=
                    companyScope.clients.length.toString() +
                    " client(s) : " +
                    companyScope.clients
                        .slice(0, 5)
                        .map((x) => x.name)
                        .join(", ") +
                    (companyScope.clients.length > 5 ? ", ..." : "");
            } else if (companyScope.taxSystems) {
                targets += " les " + companyScope.taxSystems + " de mon cabinet";
            } else if (companyScope.activities && companyScope.activities.length) {
                targets +=
                    companyScope.activities.length.toString() +
                    " activité(s) : " +
                    companyScope.activities
                        .slice(0, 5)
                        .map((x) => x.name)
                        .join(", ") +
                    (companyScope.activities.length > 5 ? ", ..." : "") +
                    " de mon cabinet";
            } else {
                targets += "tous les clients de mon cabinet";
            }
        } else if (companyScope.taxSystems) {
            targets += " les " + companyScope.taxSystems + " de tous les cabinets";
        } else if (companyScope.activities && companyScope.activities.length) {
            targets +=
                companyScope.activities.length.toString() +
                " activité(s) : " +
                companyScope.activities
                    .slice(0, 5)
                    .map((x) => x.name)
                    .join(", ") +
                (companyScope.activities.length > 5 ? ", ..." : "") +
                " de tous les cabinets";
        } else {
            targets += "tous les clients de tous les cabinets";
        }
        return targets;
    }

    @Emit("changeBookletGenerator")
    setContentToUpsert(newContent) {
        this.bundleBookletTemplate.content = newContent.booklet;
        // console.log('booklet change')
        return newContent.booklet;
    }
}

export default toNative(BookletGenerator);
</script>
